export const REMEDIATION_THROTTLE_DELAY = 300;
export const REMEDIATION_DEBOUNCE_DELAY = 500;
export const REMEDIATION_DEBOUNCE_MAX_WAIT = 2000;
export const REMEDIATION_MODE_SWITCH = 2000;
export const DEFAULT_REMEDIATION_TIMEOUT = 500;
